import { ICameraFilter } from '../../model';

const parse = (str: string): ICameraFilter => {
  const urlParams = new URLSearchParams(str);

  const skipStr = urlParams.get('skip');
  const takeStr = urlParams.get('take');

  return {
    skip: skipStr ? parseInt(skipStr) : 0,
    take: takeStr ? parseInt(takeStr) : 20,
    query: urlParams.get('query') ?? undefined,
    locationIds: urlParams.getAll('locations'),
  };
};

const toString = (filter: ICameraFilter): string => {
  return `skip=${filter.skip}&take=${filter.take}${filter.query ? `&query=${filter.query}` : ''}${filter.locationIds
    ?.map((x) => `&locations=${x}`)
    .join('')}`;
};

export const cameraFilterParser = {
  parse,
  toString,
};
